import { VENUES_QUERY_KEY } from '@domain/venues';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { archiveVenue } from '@services/venues/venuesService';
import { useQueryClient } from 'react-query';

const useArchiveVenue = (): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (venueId) => archiveVenue(venueId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(VENUES_QUERY_KEY);
      }
    }
  );
};

export { useArchiveVenue };
